module.exports = __webpack_public_path__ + "img/imagen8.e3417243.png";